import { useEffect, useState } from "react";
import arrow from "../../assets/images/right-arrow.svg";
import Title from "../../components/title/Title";
import ListItem from "../../components/listItem/ListItem";

import "./Lessons.css";
import { useHistory } from "react-router-dom";

import loadingImage from "../../assets/images/loading.gif";
import noteImg from "../../assets/images/002-post-it.png";

import axios from "axios";

import { Modal } from "antd";

const Lessons = () => {
  const history = useHistory();
  const [date, setDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [lessons, setLessons] = useState(null);
  const [isDisplayModal, setIsDisplayModal] = useState(false);
  const [isDisplayHorsesModal, setIsDisplayHorsesModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [horses, setHorses] = useState(null);
  const [note, setNote] = useState("");

  useEffect(() => {
    getLessons();
  }, [date]);

  const getHorses = async (lessonId, hour) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `/api/actions/horses/${lessonId}?date=${parseDate()}&hour=${hour}`,
        {
          headers: { Authorization: localStorage.getItem("token") },
        }
      );
      setLoading(false);
      setHorses(response.data);
      setSelectedRecord(lessonId);
      setIsDisplayHorsesModal(true);
    } catch (error) {
      setLoading(false);
    }
  };

  const getLessons = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `/api/actions/lessons?date=${parseDate()}`,
        {
          headers: { Authorization: localStorage.getItem("token") },
        }
      );
      setTimeout(() => {
        setLoading(false);
        setLessons(response.data);
      }, 1000);
    } catch (error) {
      setLoading(false);
    }
  };

  const getHebrewDay = (dayIndex) => {
    switch (dayIndex) {
      case 0:
        return "ראשון";
      case 1:
        return "שני";
      case 2:
        return "שלישי";
      case 3:
        return "רביעי";
      case 4:
        return "חמישי";
      case 5:
        return "שישי";
      case 6:
        return "שבת";
      default:
        return "";
    }
  };

  const parseDate = () => {
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  };

  const nextDay = () => {
    setDate(new Date(date.setDate(date.getDate() + 1)));
  };

  const previousDay = () => {
    setDate(new Date(date.setDate(date.getDate() - 1)));
  };

  const moveToStudent = (event, lesson) => {
    sessionStorage.setItem(
      "studentName",
      `${lesson.PrivateName} ${lesson.FamilyName}`
    );
    history.push(`/dashboard/students/${lesson.RiderId}`);
  };

  const onInputChanged = async (event, recordId, index) => {
    // event.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(
        `/api/actions/ride/${recordId}`,
        { executed: !lessons[index].executed, note: note },
        {
          headers: { Authorization: localStorage.getItem("token") },
        }
      );
      setLoading(false);
      if (response.status === 200) {
        const temp = [...lessons];
        temp[index].executed = !temp[index].executed;
        setLessons(temp);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const openNoteModal = (lesson) => {
    setSelectedRecord(lesson);
    setIsDisplayModal(true);
  };

  const selectHorse = async (horseId, horseName) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `/api/actions/horses/${selectedRecord}`,
        { horse: horseId },
        {
          headers: { Authorization: localStorage.getItem("token") },
        }
      );
      setLoading(false);
      if (response.status === 200) {
        const temp = [...lessons];
        temp.forEach((lesson) => {
          if (lesson.RecordId === selectedRecord) {
            lesson.HorseDec = horseName;
          }
        });
        setLessons(temp);
        setIsDisplayHorsesModal(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    setSelectedRecord(null);
  };

  const sendNote = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `/api/actions/ride/${selectedRecord.RecordId}`,
        { executed: selectedRecord.executed, note: note },
        {
          headers: { Authorization: localStorage.getItem("token") },
        }
      );
      setLoading(false);
      if (response.status === 200) {
        setIsDisplayModal(false);
        setSelectedRecord(null);
        setNote("");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const sendApprove = async (lesson, index) => {
    console.log(lesson, index);
    setLoading(true);
    try {
      const response = await axios.post(
        `/api/actions/lessons/${lesson.RecordId}/approve`,
        { approved: true },
        {
          headers: { Authorization: localStorage.getItem("token") },
        }
      );
      setLoading(false);
      if (response.status === 200) {
        const temp = [...lessons];
        temp[index].Approved = true;
        setLessons(temp);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div id="lessons">
      <Title text="שיעורים" />
      <div id="date">
        <div onClick={previousDay} className="changeDayDiv">
          <img src={arrow} alt="previous" />
          <span>היום הקודם</span>
        </div>
        <span id="dateSpan">{`${date.getDate()}/${
          date.getMonth() + 1
        }/${date.getFullYear()} - ${getHebrewDay(date.getDay())}`}</span>
        <div onClick={nextDay} className="changeDayDiv">
          <span>היום הבא</span>
          <img id="next" src={arrow} alt="next" />
        </div>
      </div>
      {loading ? (
        <img id="loading" src={loadingImage} alt="" />
      ) : !lessons || lessons.length === 0 ? (
        <h3>אין מידע לתצוגה</h3>
      ) : (
        <ul>
          {lessons.map((lesson, index) => {
            return (
              <li key={lesson.RecordId}>
                <div className="lesson">
                  <span id="time">{lesson.HourofRide}</span>
                  <span id="name" onClick={(e) => moveToStudent(e, lesson)}>
                    {lesson.PrivateName} {lesson.FamilyName}
                  </span>
                  {lesson.UnexecutedReson ? (
                    <span
                      style={{
                        fontSize: "12px",
                        textAlign: "right",
                        fontWeight: "bold",
                        flex: "1",
                        padding: "0 4px",
                      }}
                    >
                      ({lesson.UnexecutedReson})
                    </span>
                  ) : (
                    <span style={{ flex: "1" }}></span>
                  )}
                  <span id="horse">
                    {lesson.HorseDec ? (
                      <h3 style={{ fontWeight: "bold" }}>{lesson.HorseDec}</h3>
                    ) : (
                      <h4>לא הוגדר סוס</h4>
                    )}
                    <h5
                      onClick={() =>
                        getHorses(lesson.RecordId, lesson.HourofRide)
                      }
                    >
                      (שינוי שיבוץ)
                    </h5>
                  </span>
                  <span onClick={() => openNoteModal(lesson)}>
                    <img src={noteImg} alt="" />
                  </span>
                  {lesson.Approved === true ? (
                    <h5>אושר</h5>
                  ) : (
                    <input
                      type="checkbox"
                      onClick={() => sendApprove(lesson, index)}
                    />
                  )}
                  <div>
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={lesson.executed}
                        onChange={(e) =>
                          onInputChanged(e, lesson.RecordId, index)
                        }
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
                {/* <div
                onClick={() => {
                  moveToStudent(lesson.id);
                }}
              >
                <span>{lesson.time}</span>
                <span>{lesson.student}</span>
                <span>{lesson.horse}</span>
                <input type="checkbox" />
              </div> */}
              </li>
            );
          })}
        </ul>
      )}
      {isDisplayModal && (
        <Modal
          footer={null}
          open={isDisplayModal}
          onCancel={() => {
            setIsDisplayModal(false);
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <h3>הוספת הערה</h3>
            <textarea
              onChange={(event) => {
                setNote(event.target.value);
              }}
            ></textarea>
            <br />
            <button onClick={sendNote}>שליחת הערה</button>
          </div>
        </Modal>
      )}
      <Modal
        footer={null}
        open={isDisplayHorsesModal}
        onCancel={() => {
          setIsDisplayHorsesModal(false);
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <h2 style={{ textAlign: "center" }}>שיבוץ סוס לשיעור</h2>
          {horses && horses.length > 0 ? (
            horses.map((horse) => (
              <h3
                onClick={() => {
                  selectHorse(horse.HorseId, horse.HorseDec);
                }}
                style={{ textAlign: "center", padding: "8px 0" }}
                key={horse.HorseId}
              >
                {horse.HorseDec}
              </h3>
            ))
          ) : (
            <h3>אין סוסים לתצוגה</h3>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default Lessons;
